webpackJsonp([40],{

/***/ "L4iW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__("P4HR"));

/***/ }),

/***/ "P4HR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),

/***/ "RqsX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("PIAa");

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ContentWrapper = __webpack_require__("yfaX");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Privacy = function Privacy() {
    var StyledThing = _styledComponents2.default.article.withConfig({
        displayName: 'Privacy__StyledThing',
        componentId: 'sc-hsq501-0'
    })(['\n\n    ']);

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            _reactHelmet.Helmet,
            null,
            _react2.default.createElement('meta', { name: 'robots', content: 'noindex, nofollow' })
        ),
        _react2.default.createElement(
            'article',
            { role: 'article', about: '/legal/privacy', 'typeof': 'schema:WebPage' },
            _react2.default.createElement('span', {
                property: 'schema:name',
                content: 'Privacy',
                className: 'stolo-hidden'
            }),
            _react2.default.createElement(
                _ContentWrapper2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { property: 'schema:text' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        'Privacy Policy'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '1) Introduction and contact details of the controller'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '1.1'
                        ),
                        '\xA0We are pleased that you are visiting our website and thank you for your interest. Below we inform you about how we handle your personal data when you use our website. Personal data here means all data that can be used to identify you personally.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '1.2'
                        ),
                        '\xA0The controller responsible for data processing on this website within the meaning of the General Data Protection Regulation (DSGVO/GDPR) is Becker & Karsten UG (haftungsbeschr\xE4nkt), Sandhauser Str. 107, 13505 Berlin, Germany, Tel.: +49 30 609851960, e-mail: wir@beckerundkarsten.de. The controller responsible for the processing of personal data is the natural or legal person who alone or jointly with others determines the purposes and means of the processing of personal data.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '2) Data collection when visiting our website'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.1'
                        ),
                        '\xA0When you use our website for purely informational purposes, that is, if you do not register or otherwise transmit information to us, we collect only such data as your browser transmits to our server (so-called \u201Eserver log files\u201C). When you access our website, we collect the following data, which is technically necessary for us to display the website to you:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'The website you visited on our site'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Date and time at the moment of access'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Amount of data sent in bytes'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Source/referrer from which you reached the page'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Browser used'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Operating system used'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'IP address used (where applicable: in anonymized form)'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The processing is carried out pursuant to Art. 6(1)(f) DSGVO (GDPR) on the basis of our legitimate interest in improving the stability and functionality of our website. The data is not passed on or otherwise used. However, we reserve the right to review the server log files subsequently should there be concrete indications of unlawful use.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.2'
                        ),
                        '\xA0For security reasons and to protect the transmission of personal data and other confidential content (e.g. orders or enquiries sent to us), this website uses SSL or TLS encryption. You can recognize an encrypted connection by the character string \u201Ehttps://\u201C and the lock symbol in your browser\'s address bar.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '3) Hosting & Content Delivery Network'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.1'
                        ),
                        '\xA0Amazon Web Services'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For the hosting of our website and the presentation of its content, we use the system of the following provider: AWS EMEA SARL, 38 avenue John F. Kennedy, L-1855 Luxembourg'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Data may also be transmitted to: Amazon Web Services, Inc., 410 Terry Avenue North, Seattle, WA 98109, USA'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'All data collected on our website is processed on the provider\'s servers. We have concluded a data processing agreement with the provider that ensures the protection of our site visitors\' data and prohibits unauthorized disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to the USA, the provider has joined the EU-US Data Privacy Framework, which, on the basis of an adequacy decision of the European Commission, ensures compliance with the European level of data protection.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.2'
                        ),
                        '\xA0Cloudflare'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For the hosting of our website and the presentation of its content, we use the system of the following provider: Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107, USA'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'All data collected on our website is processed on the provider\'s servers. We have concluded a data processing agreement with the provider that ensures the protection of our site visitors\' data and prohibits unauthorized disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to the USA, the provider has joined the EU-US Data Privacy Framework, which, on the basis of an adequacy decision of the European Commission, ensures compliance with the European level of data protection.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.3'
                        ),
                        '\xA0Shopify'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For the hosting of our website and the presentation of its content, we use the system of the following provider: Shopify International Limited, Victoria Buildings, 2nd floor, 1-2 Haddington Road, Dublin 4, D04 XN32, Ireland (\u201EShopify\u201C).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Data is also transferred to: Shopify Inc., 150 Elgin St, Ottawa, ON K2P 1L4, Canada.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'All data collected on our website is processed on the provider\'s servers. We have concluded a data processing agreement with the provider that ensures the protection of our site visitors\' data and prohibits unauthorized disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to Canada, an adequate level of data protection is ensured by an adequacy decision of the European Commission.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.4'
                        ),
                        '\xA0AWS-CloudFront'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We use a content delivery network of the following provider: AWS EMEA SARL, 38 avenue John F. Kennedy, L-1855 Luxembourg'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This service enables us to deliver large media files such as graphics, page content or scripts more quickly via a network of regionally distributed servers. The processing is carried out to safeguard our legitimate interest in improving the stability and functionality of our website pursuant to Art. 6(1)(f) DSGVO (GDPR).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We have concluded a data processing agreement with the provider that ensures the protection of our site visitors\' data and prohibits unauthorized disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Data may also be transmitted to: Amazon Web Services, Inc., 410 Terry Avenue North, Seattle, WA 98109, USA'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to the USA, the provider has joined the EU-US Data Privacy Framework, which, on the basis of an adequacy decision of the European Commission, ensures compliance with the European level of data protection.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.5'
                        ),
                        '\xA0Cloudflare'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We use a content delivery network of the following provider: Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107, USA'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This service enables us to deliver large media files such as graphics, page content or scripts more quickly via a network of regionally distributed servers. The processing is carried out to safeguard our legitimate interest in improving the stability and functionality of our website pursuant to Art. 6(1)(f) DSGVO (GDPR). We have concluded a data processing agreement with the provider that ensures the protection of our site visitors\' data and prohibits unauthorized disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to the USA, the provider has joined the EU-US Data Privacy Framework, which, on the basis of an adequacy decision of the European Commission, ensures compliance with the European level of data protection.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.6'
                        ),
                        '\xA0Host Europe'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We use a content delivery network of the following provider: Host Europe GmbH, c/o WeWork, Friesenplatz 4, 50672 K\xF6ln, Germany'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This service enables us to deliver large media files such as graphics, page content or scripts more quickly via a network of regionally distributed servers. The processing is carried out to safeguard our legitimate interest in improving the stability and functionality of our website pursuant to Art. 6(1)(f) DSGVO (GDPR). We have concluded a data processing agreement with the provider that ensures the protection of our site visitors\' data and prohibits unauthorized disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.7'
                        ),
                        '\xA0Shopify'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We use a content delivery network of the following provider: Shopify International Limited, Victoria Buildings, 2nd floor, 1-2 Haddington Road, Dublin 4, D04 XN32, Ireland (\u201EShopify\u201C)'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Data may also be transferred to:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Shopify Inc., 150 Elgin St, Ottawa, ON K2P 1L4, Canada'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107, USA'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This service enables us to deliver large media files such as graphics, page content or scripts more quickly via a network of regionally distributed servers. The processing is carried out to safeguard our legitimate interest in improving the stability and functionality of our website pursuant to Art. 6(1)(f) DSGVO (GDPR). We have concluded a data processing agreement with the provider that ensures the protection of our site visitors\' data and prohibits unauthorized disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to Canada, an adequate level of data protection is ensured by an adequacy decision of the European Commission.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to the USA, the data recipient has joined the EU-US Data Privacy Framework, which, on the basis of an adequacy decision of the European Commission, ensures compliance with the European level of data protection.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '4) Cookies'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In order to make visiting our website attractive and to enable the use of certain functions, we use cookies, that is, small text files that are stored on your device. Some of these cookies are automatically deleted again after you close your browser (so-called \u201Esession cookies\u201C), while others remain on your device for longer and allow page settings to be saved (so-called \u201Epersistent cookies\u201C). In the latter case, you can find the storage period in the overview of the cookie settings of your web browser.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Insofar as personal data is also processed by individual cookies we use, the processing is carried out pursuant to Art. 6(1)(b) DSGVO (GDPR) either for the performance of the contract, pursuant to Art. 6(1)(a) DSGVO (GDPR) in the case of consent given, or pursuant to Art. 6(1)(f) DSGVO (GDPR) to safeguard our legitimate interests in the best possible functionality of the website as well as a customer-friendly and effective design of the site visit.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You can set your browser so that you are informed about the setting of cookies and can decide individually about their acceptance, or you can exclude the acceptance of cookies for certain cases or in general.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Please note that if cookies are not accepted, the functionality of our website may be limited.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '5) Contacting us'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.1'
                        ),
                        '\xA0WhatsApp Business'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We offer you the option of contacting us via the messaging service WhatsApp provided by WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland. For this purpose, we use the so-called \u201EBusiness version\u201C of WhatsApp.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you contact us by WhatsApp in connection with a specific transaction (for example an order you have placed), we store and use the mobile phone number you use on WhatsApp as well as \u2013 if provided \u2013 your first and last name pursuant to Art. 6(1)(b) DSGVO (GDPR) in order to process and respond to your request. On the same legal basis, we may, where applicable, ask you via WhatsApp to provide further data (order number, customer number, address or e-mail address) in order to be able to assign your enquiry to a particular case.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you use our WhatsApp contact for general enquiries (for example about our range of services, availability or our online presence), we store and use the mobile phone number you use on WhatsApp as well as \u2013 if provided \u2013 your first and last name pursuant to Art. 6(1)(f) DSGVO (GDPR) on the basis of our legitimate interest in providing the requested information efficiently and promptly.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Your data is always used only to respond to your request via WhatsApp. It is not passed on to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Please note that WhatsApp Business gains access to the address book of the mobile device we use for this purpose and automatically transfers phone numbers stored in the address book to a server of the parent company Meta Platforms Inc. in the USA. To operate our WhatsApp Business account, we use a mobile device in whose address book we store exclusively the WhatsApp contact details of those users who have also contacted us via WhatsApp.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This ensures that every person whose WhatsApp contact details are stored in our address book has already, when first using the app on their device, consented by accepting the WhatsApp terms of use to the transmission of their WhatsApp phone number from the address books of their chat contacts pursuant to Art. 6(1)(a) DSGVO (GDPR). A transmission of data of those users who do not use WhatsApp and/or have not contacted us via WhatsApp is therefore excluded.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For the purpose and scope of the data collection and the further processing and use of the data by WhatsApp, as well as your related rights and the settings options available to protect your privacy, please refer to the privacy notices of WhatsApp: ',
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'https://www.whatsapp.com/legal/?eea=1#privacy-policy',
                                target: '_blank' },
                            'https://www.whatsapp.com',
                            _react2.default.createElement('wbr', null),
                            '/legal',
                            _react2.default.createElement('wbr', null),
                            '/?eea=1#privacy-policy'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In the course of the processing described above, data transfers to servers of Meta Platforms Inc. in the USA may occur.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to the USA, the provider has joined the EU-US Data Privacy Framework, which, on the basis of an adequacy decision of the European Commission, ensures compliance with the European level of data protection.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.2'
                        ),
                        '\xA0When you contact us (e.g. via the contact form or e-mail), personal data is processed \u2013 exclusively for the purpose of processing and responding to your request and only to the extent necessary for this \u2013.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The legal basis for processing this data is our legitimate interest in responding to your request pursuant to Art. 6(1)(f) DSGVO (GDPR). If your contact is aimed at concluding a contract, the additional legal basis for the processing is Art. 6(1)(b) DSGVO (GDPR). Your data is deleted when it can be inferred from the circumstances that the matter in question has been conclusively clarified, provided that no statutory retention obligations prevent this.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '6) Comment function'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In the context of the comment function on this website, in addition to your comment, information about the time the comment was created and the commenter name you have chosen are stored and published on this website. Furthermore, your IP address is logged and stored. This storage of the IP address is carried out for security reasons and in case you violate the rights of third parties through a comment you post or post unlawful content. We need your e-mail address in order to contact you should a third party object to your published content as unlawful.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The legal bases for storing your data are Art. 6(1)(b) and (f) DSGVO (GDPR). We reserve the right to delete comments if they are objected to as unlawful by third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'As a user, you can subscribe to follow-up comments. You will receive a confirmation e-mail for this purpose so that it can be ensured that you are the owner of the e-mail address provided (double opt-in procedure). The legal basis for data processing in the case of subscribing to comments is Art. 6(1)(a) DSGVO (GDPR). You can cancel ongoing comment subscriptions at any time with effect for the future; for further information on how to unsubscribe, please refer to the confirmation e-mail.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '7) Data processing when opening a customer account'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Pursuant to Art. 6(1)(b) DSGVO (GDPR), personal data continues to be collected and processed to the extent necessary in each case when you provide it to us when opening a customer account. You can find out which data is required for opening an account from the input form of the relevant form on our website.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Your customer account can be deleted at any time and this can be done by sending a message to the above address of the controller. After your customer account has been deleted, your data will be deleted, provided that all contracts concluded through it have been fully processed, no statutory retention periods prevent this, and we have no remaining legitimate interest in continued storage.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '8) Use of customer data for direct advertising'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '8.1'
                        ),
                        '\xA0Subscription to our e-mail newsletter'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you subscribe to our e-mail newsletter, we will regularly send you information about our offers. The only mandatory information for sending the newsletter is your e-mail address. Providing further data is voluntary and is used to be able to address you personally. For sending the newsletter, we use the so-called double opt-in procedure, which ensures that you only receive the newsletter once you have expressly confirmed your consent to receiving the newsletter by clicking a verification link sent to the e-mail address provided.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'By activating the confirmation link, you give us your consent to the use of your personal data pursuant to Art. 6(1)(a) DSGVO (GDPR). In doing so, we store the IP address assigned by your internet service provider (ISP) as well as the date and time of the registration, in order to be able to trace any possible misuse of your e-mail address at a later point in time. The data collected by us when you subscribe to the newsletter is used strictly for the stated purpose.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You can unsubscribe from the newsletter at any time via the link provided for this purpose in the newsletter or by a corresponding message to the controller named at the beginning. After you have unsubscribed, your e-mail address will be deleted immediately from our newsletter distribution list, unless you have expressly consented to further use of your data or we reserve the right to use the data beyond this in a way that is legally permitted and about which we inform you in this statement.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '8.2'
                        ),
                        '\xA0MailChimp'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Our e-mail newsletters are sent via the following provider: The Rocket Science Group, LLC d/b/a MailChimp, 675 Ponce de Leon Ave NE, Suite 5000, Atlanta, GA 30308, USA.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'On the basis of our legitimate interest in effective and user-friendly newsletter marketing, we pass on the data you provided when subscribing to the newsletter to this provider pursuant to Art. 6(1)(f) DSGVO (GDPR) so that it handles the sending of the newsletter on our behalf.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Subject to your express consent pursuant to Art. 6(1)(a) DSGVO (GDPR), the provider also carries out a statistical evaluation of the success of newsletter campaigns by means of web beacons or tracking pixels in the e-mails sent, which can measure opening rates and specific interactions with the content of the newsletter. In doing so, device information (e.g. time of access, IP address, browser type and operating system) is also collected and evaluated, but not combined with other data sets.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You can revoke your consent to newsletter tracking at any time with effect for the future.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We have concluded a data processing agreement with the provider that protects the data of our site visitors and prohibits disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to the USA, the provider has joined the EU-US Data Privacy Framework, which, on the basis of an adequacy decision of the European Commission, ensures compliance with the European level of data protection.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '9) Data processing for order fulfilment'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.1'
                        ),
                        '\xA0Transmission of image files for order fulfilment by e-mail'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'On our website we offer you the option of commissioning the personalization of products by transmitting image files by e-mail. The submitted image motif is then used as a template for the personalization of the selected product.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Via the e-mail address provided on the website, you can transmit one or more image files from the storage of the device you use to us. We then collect, store and use the files transmitted in this way exclusively for the production of the personalized product in accordance with the respective service description on our website. Insofar as the transmitted image files are passed on to special service providers for the production and fulfilment of the order, you will be explicitly informed about this in the following paragraphs. No disclosure beyond this takes place. Insofar as the transmitted files or the digital motifs contain personal data (in particular images of identifiable persons), all the processing operations just named are carried out exclusively for the purpose of processing your online order pursuant to Art. 6(1)(b) DSGVO (GDPR).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'After the order has been finally processed, the transmitted image files are automatically and completely deleted.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.2'
                        ),
                        '\xA0Transmission of image files for order fulfilment via upload function'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'On our website we offer you the option of commissioning the personalization of products by transmitting image files via an upload function. The submitted image motif is then used as a template for the personalization of the selected product.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Via the upload form on the website, you can transmit one or more image files from the storage of the device you use directly to us by automated, encrypted data transmission. We then collect, store and use the transmitted files exclusively for the production of the personalized product in accordance with the respective service description on our website. Insofar as the transmitted image files are passed on to special service providers for the production and fulfilment of the order, you will be explicitly informed about this in the following paragraphs. No disclosure beyond this takes place. Insofar as the transmitted files or the digital motifs contain personal data (in particular images of identifiable persons), all the processing operations just named are carried out exclusively for the purpose of processing your online order pursuant to Art. 6(1)(b) DSGVO (GDPR).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'After the order has been finally processed, the transmitted image files are automatically and completely deleted.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.3'
                        ),
                        '\xA0Insofar as necessary for the performance of the contract for delivery and payment purposes, the personal data collected by us is passed on pursuant to Art. 6(1)(b) DSGVO (GDPR) to the commissioned transport company and the commissioned credit institution.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Insofar as we owe you updates for goods with digital elements or for digital products on the basis of a corresponding contract, we process the contact data you provided when ordering (name, address, e-mail address) in order to inform you personally, within the scope of our statutory information obligations pursuant to Art. 6(1)(c) DSGVO (GDPR), by a suitable means of communication (such as by post or e-mail) about upcoming updates within the period provided for by law. Your contact data is used here strictly for the purpose of notifications about updates owed by us and is processed by us for this purpose only to the extent necessary for the respective information.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'To process your order, we also work with the following service provider(s), who support us wholly or partly in carrying out concluded contracts. Certain personal data is transmitted to these service providers in accordance with the following information.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.4'
                        ),
                        '\xA0Billbee'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For order fulfilment we use the following provider: Billbee GmbH, Arolser Str. 10, 34477 Twistetal'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Name, address and, where applicable, further personal data is passed on to the provider pursuant to Art. 6(1)(b) DSGVO (GDPR) exclusively for the purpose of processing your online order. Your data is only passed on here insofar as it is actually necessary for processing the order.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.5'
                        ),
                        '\xA0Shopify Digital Download'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For order fulfilment we use the following provider: Shopify International Limited, Victoria Buildings, 2nd floor, 1-2 Haddington Road, Dublin 4, D04 XN32, Ireland'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Name, address and, where applicable, further personal data is passed on to the provider pursuant to Art. 6(1)(b) DSGVO (GDPR) exclusively for the purpose of processing the online order. Your data is only passed on here insofar as it is actually necessary for processing the order.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.6'
                        ),
                        '\xA0Disclosure of personal data to shipping service providers'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '- Deutsche Post'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'As a transport service provider, we use the following provider: Deutsche Post AG, Charles-de-Gaulle-Stra\xDFe 20, 53113 Bonn, Germany'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We pass on your e-mail address and/or telephone number pursuant to Art. 6(1)(a) DSGVO (GDPR) to the provider before delivery of the goods for the purpose of coordinating a delivery date or for delivery notification, provided that you have given your express consent for this during the ordering process. Otherwise, for the purpose of delivery, we pass on to the provider pursuant to Art. 6(1)(b) DSGVO (GDPR) only the recipient\'s name and the delivery address. The disclosure takes place only insofar as it is necessary for the delivery of the goods. In this case, prior coordination of the delivery date with the provider or delivery notification is not possible.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Consent can be revoked at any time with effect for the future vis-\xE0-vis the controller named above or vis-\xE0-vis the provider.',
                        _react2.default.createElement('br', null),
                        '- DHL'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'As a transport service provider, we use the following provider: DHL Paket GmbH, Str\xE4\xDFchensweg 10, 53113 Bonn, Germany'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We pass on your e-mail address and/or telephone number pursuant to Art. 6(1)(a) DSGVO (GDPR) to the provider before delivery of the goods for the purpose of coordinating a delivery date or for delivery notification, provided that you have given your express consent for this during the ordering process. Otherwise, for the purpose of delivery, we pass on to the provider pursuant to Art. 6(1)(b) DSGVO (GDPR) only the recipient\'s name and the delivery address. The disclosure takes place only insofar as it is necessary for the delivery of the goods. In this case, prior coordination of the delivery date with the provider or delivery notification is not possible.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Consent can be revoked at any time with effect for the future vis-\xE0-vis the controller named above or vis-\xE0-vis the provider.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.7'
                        ),
                        '\xA0Use of payment service providers (payment services)'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '- Paypal'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'On this website, one or more online payment methods of the following provider are available: PayPal (Europe) S.a.r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you select a payment method of the provider where you pay in advance, the payment data you provide during the order process (including name, address, bank and payment card information, currency and transaction number) as well as information about the content of your order is passed on to the provider pursuant to Art. 6(1)(b) DSGVO (GDPR). In this case, your data is passed on exclusively for the purpose of payment processing with the provider and only insofar as it is necessary for this.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you select a payment method where we pay in advance, you will also be asked during the order process to provide certain personal data (first and last name, street, house number, postal code, city, date of birth, e-mail address, telephone number, and where applicable data on an alternative means of payment).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In such cases, in order to safeguard our legitimate interest in establishing your ability to pay, this data is forwarded by us pursuant to Art. 6(1)(f) DSGVO (GDPR) to the provider for the purpose of a credit check. On the basis of the personal data you have provided as well as further data (such as shopping cart, invoice amount, order history, payment experience), the provider checks whether the payment option you have selected can be granted with regard to payment and/or default risks.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The credit report may contain probability values (so-called score values). Insofar as score values are included in the result of the credit report, they are based on a scientifically recognized mathematical-statistical procedure. The calculation of the score values includes, among other things but not exclusively, address data.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You can object to this processing of your data at any time by a message to us or vis-\xE0-vis the provider. However, the provider may, where applicable, remain entitled to process your personal data insofar as this is necessary for contractual payment processing.',
                        _react2.default.createElement('br', null),
                        '- Stripe'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'On this website, one or more online payment methods of the following provider are available: Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Ireland'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you select a payment method of the provider where you pay in advance (for example credit card payment), the payment data you provide during the order process (including name, address, bank and payment card information, currency and transaction number) as well as information about the content of your order is passed on to the provider pursuant to Art. 6(1)(b) DSGVO (GDPR). In this case, your data is passed on exclusively for the purpose of payment processing with the provider and only insofar as it is necessary for this.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you select a payment method where the provider pays in advance (for example purchase on account or in instalments or direct debit), you will also be asked during the order process to provide certain personal data (first and last name, street, house number, postal code, city, date of birth, e-mail address, telephone number, and where applicable data on an alternative means of payment).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In order to safeguard our legitimate interest in establishing the ability of our customers to pay, this data is forwarded by us pursuant to Art. 6(1)(f) DSGVO (GDPR) to the provider for the purpose of a credit check. On the basis of the personal data you have provided as well as further data (such as shopping cart, invoice amount, order history, payment experience), the provider checks whether the payment option you have selected can be granted with regard to payment and/or default risks.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The credit report may contain probability values (so-called score values). Insofar as score values are included in the result of the credit report, they are based on a scientifically recognized mathematical-statistical procedure. The calculation of the score values includes, among other things but not exclusively, address data.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You can object to this processing of your data at any time by a message to us or vis-\xE0-vis the provider. However, the provider may, where applicable, remain entitled to process your personal data insofar as this is necessary for contractual payment processing.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.8'
                        ),
                        '\xA0Electronic withdrawal function for distance contracts'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Consumers who conclude contracts on this website for which a statutory right of withdrawal exists have the option of declaring the withdrawal via an electronic withdrawal function in accordance with the applicable withdrawal provisions.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'When using the withdrawal function, in addition to details for identifying the contract to be withdrawn, further personal information such as the consumer\'s first and last name as well as e-mail address must be provided or confirmed.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The collection of this information and its transmission to us is carried out here pursuant to Art. 6(1)(b) DSGVO (GDPR) and only insofar as it is necessary for the proper processing of the withdrawal. Also on the basis of Art. 6(1)(b) DSGVO (GDPR), the personal data provided is used to confirm receipt of the declaration of withdrawal by e-mail. A further legal basis for the processing is Art. 6(1)(c) DSGVO (GDPR). We are legally obliged to provide an electronic withdrawal function for paid consumer distance contracts.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '10) Site functionalities'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.1'
                        ),
                        '\xA0Facebook Connect'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'On our website we provide a single sign-on function of the following provider: Meta Platforms Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In addition to a transmission of data to the above-mentioned provider location, data may also be transmitted to: Meta Platforms Inc., USA.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you have an account with the provider, you can use these account details to log in to create a user account or to register on our website.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'When you visit this site, this login function may establish a direct connection between your browser and the provider\'s servers, even if you do not have an account with the provider or are not logged into one. The provider thereby receives the information that you have visited our site. The information collected in this respect (where applicable including your IP address) is transmitted by your browser directly to a server of the provider and stored there. The information is, however, not used to identify you personally and is not passed on to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'These data processing operations are carried out pursuant to Art. 6(1)(f) DSGVO (GDPR) on the basis of our legitimate interest in a user-friendly and interactive design of our online presence.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you click the login button to register on our website with the data of your account with the provider, the provider transmits to us, exclusively on the basis of your express consent pursuant to Art. 6(1)(a) DSGVO (GDPR), the general and publicly accessible information stored in your account (user ID, name, address, e-mail address, age and gender).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We store and use the data transmitted by the provider to set up a user account with the necessary data (salutation, first name, last name, address data, country, e-mail address, date of birth), provided that you have released this to the provider. Conversely, on the basis of your consent, data (e.g. information about your browsing or purchasing behaviour) may be transferred by us to your account with the provider.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The consent given can be revoked at any time with effect for the future vis-\xE0-vis us.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to the USA, the provider has joined the EU-US Data Privacy Framework, which, on the basis of an adequacy decision of the European Commission, ensures compliance with the European level of data protection.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.2'
                        ),
                        '\xA0Google Sign-In'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'On our website we provide a single sign-on function of the following provider: Google Ireland Limited, Gordon House, 4 Barrow St, Dublin, D04 E5W5, Ireland.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In addition to a transmission of data to the above-mentioned provider location, data may also be transmitted to: Google LLC, USA.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you have an account with the provider, you can use these account details to log in to create a user account or to register on our website.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'When you visit this site, this login function may establish a direct connection between your browser and the provider\'s servers, even if you do not have an account with the provider or are not logged into one. The provider thereby receives the information that you have visited our site. The information collected in this respect (where applicable including your IP address) is transmitted by your browser directly to a server of the provider and stored there. The information is, however, not used to identify you personally and is not passed on to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'These data processing operations are carried out pursuant to Art. 6(1)(f) DSGVO (GDPR) on the basis of our legitimate interest in a user-friendly and interactive design of our online presence.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you click the login button to register on our website with the data of your account with the provider, the provider transmits to us, exclusively on the basis of your express consent pursuant to Art. 6(1)(a) DSGVO (GDPR), the general and publicly accessible information stored in your account (user ID, name, address, e-mail address, age and gender).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We store and use the data transmitted by the provider to set up a user account with the necessary data (salutation, first name, last name, address data, country, e-mail address, date of birth), provided that you have released this to the provider. Conversely, on the basis of your consent, data (e.g. information about your browsing or purchasing behaviour) may be transferred by us to your account with the provider.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The consent given can be revoked at any time with effect for the future vis-\xE0-vis us.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For data transfers to the USA, the provider has joined the EU-US Data Privacy Framework, which, on the basis of an adequacy decision of the European Commission, ensures compliance with the European level of data protection.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You can find further information on Google\'s data protection here: ',
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'https://business.safety.google/intl/de/privacy/',
                                target: '_blank' },
                            'https://business.safety.google',
                            _react2.default.createElement('wbr', null),
                            '/intl',
                            _react2.default.createElement('wbr', null),
                            '/de',
                            _react2.default.createElement('wbr', null),
                            '/privacy',
                            _react2.default.createElement('wbr', null),
                            '/'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.3'
                        ),
                        '\xA0OpenStreetMap'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This website uses an online map service of the following provider: OpenStreetMap Foundation, St John\u2019s Innovation Centre, Cowley Road, Cambridge, CB4 0WS, UK'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The online map service is a tool for displaying interactive maps in order to present geographical information visually. Through the use of this service, our location is shown to you and any geolocation is facilitated.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Already when you call up those subpages in which the provider\'s map is embedded, information about your use of our website (such as your IP address) is transferred to the provider\'s servers and stored there.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The processing of your personal data is carried out pursuant to Art. 6(1)(f) DSGVO (GDPR) on the basis of our legitimate interest in the needs-based design of our website. If you do not agree with the future transmission of your data to the provider, there is the option of completely deactivating the provider\'s online map service by switching off the JavaScript application in your browser. The online map service on this website can then no longer be used.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Insofar as legally required, we have obtained your consent for the processing of your data as described above pursuant to Art. 6(1)(a) DSGVO (GDPR). You can revoke the consent you have given at any time with effect for the future. To exercise your withdrawal, please follow the option for raising an objection described above.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For a data transfer to the provider location, an adequate level of data protection is ensured by an adequacy decision of the European Commission.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.4'
                        ),
                        '\xA0- Friendly Captcha'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'On this website we use the CAPTCHA service of the following provider: Friendly Captcha GmbH, Am Anger 3-5, 82237 W\xF6rthsee'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The service checks whether an entry is made by a natural person or abusively by mechanical and automated processing, and blocks spam, DDoS attacks and similar automated malicious access.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'When you call up a page of our website that contains the provider\'s captcha elements, your browser establishes a direct connection to the provider\'s servers in order to load the elements properly. In doing so, certain browser information, including your IP address, is transmitted to the provider.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The legal basis is our legitimate interest in establishing individual personal responsibility on the internet and in avoiding misuse and spam pursuant to Art. 6(1)(f) DSGVO (GDPR).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Following the transmission, the collected browser information is automatically and immediately anonymized, so that no personal data is processed for the verification of the human origin of a page interaction.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We have concluded a data processing agreement with the provider that ensures the protection of our site visitors\' data and prohibits unauthorized disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '11) Tools and miscellaneous'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.1'
                        ),
                        '\xA0Billbee'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'To handle your accounting, we use the cloud-based accounting software service of the following provider: Billbee GmbH, Arolser Str. 10, 34477 Twistetal, Germany.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The provider processes incoming and outgoing invoices as well as, where applicable, the bank transactions of our company, in order to automatically record invoices, match them to transactions and, from this, prepare the financial accounting in a partially automated process.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Insofar as personal data is also processed in the process, the processing is carried out on the basis of our legitimate interest in the efficient organization and documentation of our business transactions.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.2'
                        ),
                        '\xA0BuchhaltungsButler'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'To handle your accounting, we use the cloud-based accounting software service of the following provider: BuchhaltungsButler GmbH, Ausbau 1, 15910 Unterspreewald, Germany'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The provider processes incoming and outgoing invoices as well as, where applicable, the bank transactions of our company, in order to automatically record invoices, match them to transactions and, from this, prepare the financial accounting in a partially automated process.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Insofar as personal data is also processed in the process, the processing is carried out on the basis of our legitimate interest in the efficient organization and documentation of our business transactions.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.3'
                        ),
                        '\xA0Cookie consent tool'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'To obtain effective user consent for cookies requiring consent and cookie-based applications, this website uses a so-called \u201Ecookie consent tool\u201C. The \u201Ecookie consent tool\u201C is displayed to you when you access the site in the form of an interactive user interface on which you can grant consent for certain cookies and/or cookie-based applications by ticking boxes. By using the tool, all cookies/services requiring consent are loaded only if you grant the corresponding consents by ticking boxes. This ensures that such cookies are set on your respective device only in the case of consent given.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The tool sets technically necessary cookies in order to store your cookie preferences. As a rule, personal user data is not processed in the process.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If, in individual cases, personal data (such as the IP address) is nevertheless processed for the purpose of storing, assigning or logging cookie settings, this is carried out pursuant to Art. 6(1)(f) DSGVO (GDPR) on the basis of our legitimate interest in legally compliant, user-specific and user-friendly consent management for cookies and thus in a legally compliant design of our online presence.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'A further legal basis for the processing is also Art. 6(1)(c) DSGVO (GDPR). As controllers, we are subject to the legal obligation to make the use of technically non-necessary cookies dependent on the respective user consent.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Insofar as necessary, we have concluded a data processing agreement with the provider that ensures the protection of our site visitors\' data and prohibits unauthorized disclosure to third parties.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You can find further information on the operator and the settings options of the cookie consent tool directly in the corresponding user interface on our website.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '12) Rights of the data subject'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.1'
                        ),
                        '\xA0Applicable data protection law grants you, with regard to the processing of your personal data, the following data subject rights (rights to information and intervention) vis-\xE0-vis us as the controller, whereby reference is made to the cited legal basis for the respective conditions for exercising them:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Right of access pursuant to Art. 15 DSGVO (GDPR);'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Right to rectification pursuant to Art. 16 DSGVO (GDPR);'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Right to erasure pursuant to Art. 17 DSGVO (GDPR);'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Right to restriction of processing pursuant to Art. 18 DSGVO (GDPR);'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Right to be informed pursuant to Art. 19 DSGVO (GDPR);'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Right to data portability pursuant to Art. 20 DSGVO (GDPR);'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Right to withdraw consent given pursuant to Art. 7(3) DSGVO (GDPR);'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Right to lodge a complaint pursuant to Art. 77 DSGVO (GDPR).'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.2'
                        ),
                        '\xA0RIGHT TO OBJECT'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'IF, WITHIN THE SCOPE OF A BALANCING OF INTERESTS, WE PROCESS YOUR PERSONAL DATA ON THE BASIS OF OUR OVERRIDING LEGITIMATE INTEREST, YOU HAVE THE RIGHT AT ANY TIME, ON GROUNDS RELATING TO YOUR PARTICULAR SITUATION, TO OBJECT TO THIS PROCESSING WITH EFFECT FOR THE FUTURE.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'IF YOU EXERCISE YOUR RIGHT TO OBJECT, WE WILL END THE PROCESSING OF THE DATA CONCERNED. HOWEVER, FURTHER PROCESSING REMAINS RESERVED IF WE CAN DEMONSTRATE COMPELLING LEGITIMATE GROUNDS FOR THE PROCESSING WHICH OVERRIDE YOUR INTERESTS, FUNDAMENTAL RIGHTS AND FREEDOMS, OR IF THE PROCESSING SERVES THE ESTABLISHMENT, EXERCISE OR DEFENCE OF LEGAL CLAIMS.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'IF YOUR PERSONAL DATA IS PROCESSED BY US FOR THE PURPOSE OF DIRECT ADVERTISING, YOU HAVE THE RIGHT TO OBJECT AT ANY TIME TO THE PROCESSING OF PERSONAL DATA CONCERNING YOU FOR THE PURPOSE OF SUCH ADVERTISING. YOU CAN EXERCISE THE OBJECTION AS DESCRIBED ABOVE.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'IF YOU EXERCISE YOUR RIGHT TO OBJECT, WE WILL END THE PROCESSING OF THE DATA CONCERNED FOR DIRECT ADVERTISING PURPOSES.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '13) Duration of the storage of personal data'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The duration of the storage of personal data is determined on the basis of the respective legal basis, the purpose of processing and \u2013 where applicable \u2013 additionally on the basis of the respective statutory retention period (e.g. retention periods under commercial and tax law).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'When personal data is processed on the basis of express consent pursuant to Art. 6(1)(a) DSGVO (GDPR), the data concerned is stored until you revoke your consent.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If statutory retention periods exist for data that is processed within the framework of legal or quasi-legal obligations on the basis of Art. 6(1)(b) DSGVO (GDPR), this data is routinely deleted after expiry of the retention periods, provided that it is no longer required for the performance or initiation of the contract and/or we have no remaining legitimate interest in continued storage.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'When personal data is processed on the basis of Art. 6(1)(f) DSGVO (GDPR), this data is stored until you exercise your right to object under Art. 21(1) DSGVO (GDPR), unless we can demonstrate compelling legitimate grounds for the processing which override your interests, rights and freedoms, or the processing serves the establishment, exercise or defence of legal claims.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'When personal data is processed for the purpose of direct advertising on the basis of Art. 6(1)(f) DSGVO (GDPR), this data is stored until you exercise your right to object under Art. 21(2) DSGVO (GDPR).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Unless otherwise stated in the other information in this statement on specific processing situations, stored personal data is otherwise deleted when it is no longer necessary for the purposes for which it was collected or otherwise processed.'
                    )
                )
            )
        )
    );
};

exports.default = Privacy;

/***/ }),

/***/ "UU+7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Privacy = __webpack_require__("RqsX");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Privacy).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "yfaX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__("L4iW");

var _Paper2 = _interopRequireDefault(_Paper);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWrapper = (0, _styledComponents2.default)(_Paper2.default).withConfig({
  displayName: 'ContentWrapper',
  componentId: 'sc-1b74oo9-0'
})(['\n  margin: ', ' 0;\n  padding: ', ';\n  position: relative;\n    \n    & p {\n      line-height: 1.61em;\n      margin-bottom: ', ';\n      max-width: ', ';\n    }\n\n    & h1, h2, h3, h4, h5, h6 {\n      margin: ', ' 0 ', ';\n    }\n    \n    & img {\n      max-width: 100%;\n    }\n\n'], function (props) {
  return props.theme.space[12];
}, function (props) {
  return props.theme.space[10];
}, function (props) {
  return props.theme.space[9];
}, function (props) {
  return props.theme.space[23];
}, function (props) {
  return props.theme.space[7];
}, function (props) {
  return props.theme.space[12];
});

exports.default = ContentWrapper;

/***/ })

});


// WEBPACK FOOTER //
// async/enPrivacy.ac865fcf9238305c808a.js